import React from 'react'
import s from './meterVerif.module.css'
import { HiOutlineChevronRight } from "react-icons/hi2";

function RemoteData() {
  return (
    <div className={s.remoteData}>
      <div className={s.container} >
        <div className={s.blockTree}>
              <span className={s.item} >Услуги</span>
              <HiOutlineChevronRight />
               <span className={s.item}>Поверка счетчиков воды и тепла</span>
            </div>
            
            <h2>
              <span className={s.text11}>Поверка</span> счетчиков воды и тепла {" "}
            </h2>
      </div>
      
    </div>
  )
}

export default RemoteData